import React from 'react'
import { LayoutProps } from '../common.interface'

function Layout(props:LayoutProps) {
  return (
    <div className='flex h-full items-center justify-center w-auto bg-cover' style={{backgroundImage:"url('../assets/authBackground.png')"}} >{props.children}</div>
  )
}

export default Layout